// extracted by mini-css-extract-plugin
export default {"image":"background__image__d0N2A","color":"background__color__nZ6El","video":"background__video__qiWwy","videoEnabled":"background__videoEnabled__EGSme"};